import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { actions } from '../actions/app';
import UserRegisterForm from '../components/features/UserRegisterForm';

class UserRegisterFormContainer extends React.PureComponent {
  render() {
    return (
      <UserRegisterForm {...this.props} />
    );
  }
}

const getState = state => ({
});

const getActions = dispatch => bindActionCreators({
  onSubmit: actions.apiAppRegisterRequest,
}, dispatch);

export default connect(getState, getActions)(UserRegisterFormContainer);



// WEBPACK FOOTER //
// ./src/containers/UserRegisterFormContainer.js